import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  emailAddressIconLabel: {
    defaultMessage: 'Copy Email Address',
    description: 'Label for email address icon',
    id: 'TE5txb',
  },
});
